var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('loading-overlay'):_c('div',[_vm._t("header",function(){return [_c('header-top-info'),_c('Header')]}),_c('div',{class:{'background-wrapper': _vm.bgWrapper}},[_c('div',{class:_vm.classes},[_vm._t("content")],2)]),_vm._t("footer",function(){return [_c('Footer')]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }